import {
  IActivityLog,
  DateRangePickerValue,
  EventType,
} from 'src/app/interfaces/IActivityLog';
import { eventTypeMapping } from './constants';
import { IOption } from '../groups/interfaces';

export const getLogUsersEmails = (
  activityLogData: IActivityLog[],
  selectedUsers: string[]
): IOption[] => {
  if (!activityLogData) return [];
  return activityLogData.map((log: IActivityLog) => {
    const isSelected = selectedUsers.includes(log.user);
    return {
      label: log.user,
      value: log.user,
      selected: isSelected,
    };
  });
};

export const getSubTypes = (selectedSubtypes: string[]): IOption[] => {
  return Object.entries(eventTypeMapping).map(([eventType, label]) => {
    const isSelected = selectedSubtypes.includes(eventType);
    return {
      label,
      value: eventType,
      selected: isSelected,
    };
  });
};

export const formatDateToMMDDYYYY = (dateInput: string | Date): string => {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  };

  return date.toLocaleDateString('en-US', options);
};

export function getInitialDefaultRange(createdAt: string): [Date, Date] {
  const createdAtDate = new Date(createdAt);
  const endDate = new Date();

  const ninetyDaysAgo = new Date();
  ninetyDaysAgo.setDate(endDate.getDate() - 90);

  const startDate =
    createdAtDate < ninetyDaysAgo ? ninetyDaysAgo : createdAtDate;

  return [startDate, endDate];
}

export function parseDateRangePickerValue(
  initialFetchedRange: DateRangePickerValue
): DateRangePickerValue {
  if (initialFetchedRange && initialFetchedRange.length === 2) {
    return [
      typeof initialFetchedRange[0] === 'string'
        ? new Date(initialFetchedRange[0])
        : initialFetchedRange[0],
      typeof initialFetchedRange[1] === 'string'
        ? new Date(initialFetchedRange[1])
        : initialFetchedRange[1],
    ];
  }
  return initialFetchedRange === null ? null : undefined;
}

function formatTimestamp(timestamp: string): string {
  const date = new Date(timestamp);
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC',
  }).format(date);
}

function formatLog(
  log: IActivityLog
): IActivityLog & { eventType: string; timestamp: string } {
  const formattedTimestamp = formatTimestamp(log.timestamp);
  return {
    ...log,
    eventType: eventTypeMapping[log.eventType as EventType],
    timestamp: formattedTimestamp as EventType,
  };
}

export function formatLogs(
  logs: IActivityLog[]
): Array<IActivityLog & { eventType: string }> {
  if (Array.isArray(logs)) {
    return logs.map(formatLog);
  } else {
    return [];
  }
}
